import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './components/header/Header';
import Navigation from './components/navigation/Navigation';
import Footer from './components/footer/Footer';

function App() {
  return (
    <>
      <Header />
      <Navigation />
      <main className="w-full h-full pt-[0px]">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default App;
